// extracted by mini-css-extract-plugin
module.exports = {"rate":"rate_rate__3dwbk","theloading":"rate_theloading__2uLNV"};